import * as Base from '../../../base';
import type { OperatorSwitchProps } from './types';
import type { ReactElement } from 'react';

export function OperatorSwitch({ value, options, onChange }: OperatorSwitchProps): ReactElement {
  return (
    <Base.Radio.Group value={value} onChange={onChange}>
      {options.map(optionItem => (
        <Base.Radio.Button value={optionItem.value} key={optionItem.label}>
          {optionItem.label}
        </Base.Radio.Button>
      ))}
    </Base.Radio.Group>
  );
}
